// extracted by mini-css-extract-plugin
export default {"root":"styles_root__9ct9G","dragging-over":"styles_dragging-over__Btlau","draggingOver":"styles_dragging-over__Btlau","color":"styles_color__rsG0o"};